import services from "@src/Services";
import { getPropertyCustomExtraPath } from "@src/constants/Dashboard";
import { getCurrentTimezoneTimestamp } from "@src/utils/timezone";

export const LABOUR_COGS_TITLE = {
  LABOUR: "Labour Summary",
  COGS: "COGS Summary",
};

export const NOTES_TITLE = "Notes";

export const getCustomExtraPathTableDashboard = (
  customFilter: CustomFilterType
) => {
  let path = "";
  const {
    property,
    store,
    rvc,
    date,
    identifier,
    sortingType,
    page,
    filterBy,
  } = customFilter || {};

  if (property) {
    path += `?property=${property?.toString().trim()}`;
  }

  if (store) {
    path += `&store=${store?.toString().trim()}`;
  }

  if (rvc) {
    path += `&rvc=${rvc?.toString().trim()}`;
  }

  if (date) {
    path += `&date=${date?.toString().trim()}`;
  }

  if (identifier) {
    path += `&sort_by=${identifier?.toString()}`;
  }

  if (sortingType) {
    path += `&sort_order=${sortingType?.toString()}`;
  }

  if (filterBy) {
    path += `&filter_by=${filterBy?.toString()}`;
  }

  if (page) {
    path += `&page=${page?.toString()}`;
  }

  let url = path;
  if (path.length && path[0] !== "?") {
    url = url.replace("&", "?");
  }
  return url;
};

export const getCustomExtraPathDashboard = (filters: FilterType) => {
  let path = "";

  const customPath = getPropertyCustomExtraPath(filters);

  path = customPath;

  let url = path;
  if (path.length && path[0] !== "?") {
    url = url.replace("&", "?");
  }
  return url;
};

export const getCustomExtraPathMainDashboard = (
  filters: DashboardFilterType
) => {
  let path = "";
  const { planData, foreCastData } = filters || {};

  const customPath = getPropertyCustomExtraPath(filters);

  path = customPath;

  if (foreCastData) {
    path += `&target=forecast`;
  }

  if (planData) {
    path += `&target=plan`;
  }

  let url = path;
  if (path.length && path[0] !== "?") {
    url = url.replace("&", "?");
  }
  return url;
};

export const getHomePageData = async (filters: DashboardFilterType) => {
  try {
    const advancedFilterExtraPath = getCustomExtraPathMainDashboard({
      ...filters,
    });

    const customPath = `${advancedFilterExtraPath}`;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const res: any = await services.get(`/home-api${customPath}`);

    if (!res.error) {
      return { data: res?.data?.data };
    }
    return { data: null, error: "Something went wrong !" };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    return {
      error: err?.error?.message || "Something went wrong!",
    };
  }
};

export const getNoteData = async (query: NotesQueryType) => {
  try {
    const res = (await services.get(`/note`, query)) as noteResponse;
    return { data: res?.data?.data };
  } catch (err) {
    if (err && typeof err === "object") {
      const typedError = err as ErrorResponseType;
      return {
        error: typedError?.error?.message,
      };
    }
    return {
      error: "Something went wrong!",
    };
  }
};

export const createNote = async (request: CreateNoteType) => {
  try {
    const res = (await services.post(`/note`, request)) as notePostResponse;
    return { data: res.data };
  } catch (err) {
    if (err && typeof err === "object") {
      const typedError = err as ErrorResponseType;
      return {
        error: typedError?.error?.message,
      };
    }
    return {
      error: "Something went wrong!",
    };
  }
};

export const updateNote = async (request: NotesUpdateType) => {
  try {
    const body = {
      content: request.content,
      sectionId: request.sectionId,
      entryId: request.entryId,
      timestamp: getCurrentTimezoneTimestamp(), // Add client timestamp
    };
    const res = (await services.post(
      `/note/${request.noteId}`,
      body
    )) as notePostResponse;
    return { data: res.data };
  } catch (err) {
    if (err && typeof err === "object") {
      const typedError = err as ErrorResponseType;
      return {
        error: typedError?.error?.message,
      };
    }
    return {
      error: "Something went wrong!",
    };
  }
};

export const sendEmailsRequest = async (noteId: number) => {
  try {
    const res = (await services.post(
      `/mail-eon/${noteId}`,
      {}
    )) as notePostResponse;
    return { res };
  } catch (err) {
    if (err && typeof err === "object") {
      const typedError = err as ErrorResponseType;
      return {
        error: typedError?.error?.message,
      };
    }
    return {
      error: "Something went wrong!",
    };
  }
};
